import { RewardsAccount } from "redmond";

export interface PremiumStaysEarnInfo {
  earnMultiplier: number;
  payLaterMultiplier: number;
  rewardCurrency: string;
}

const DEFAULT_EARN_MULTIPLIER = 5;
const POINTS_PAY_LATER_MULTIPLIER = 1;
const DEFAULT_PAY_LATER_MULTIPLIER = 2;

export const getPremiumStaysEarnInfo = (
  account?: RewardsAccount | null
): PremiumStaysEarnInfo => {
  const rewardCurrency =
    account?.rewardsBalance?.currencyDescription ?? "miles";

  return {
    earnMultiplier:
      account?.earn?.premierCollectionMultiplier ??
      account?.earn?.hotelsMultiplier ??
      DEFAULT_EARN_MULTIPLIER,
    payLaterMultiplier:
      rewardCurrency === "points"
        ? POINTS_PAY_LATER_MULTIPLIER
        : DEFAULT_PAY_LATER_MULTIPLIER,
    rewardCurrency,
  };
};
